import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { KeyValueId, KeyValues5, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-more-actions',
  templateUrl: './more-actions.component.html',
  styleUrl: './more-actions.component.scss'
})
export class MoreActionsComponent {
  @ViewChild('content_more_action')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onClicked = new EventEmitter();

  @Input() title: string = '';
  @Input() items: KeyValues5[] = []; quickSearchKey: string = '';

  htmlId: string = ''; elementIds: any; sideBarBodyHeight: number = 10;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private router: Router) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      btn_navigate: 'btn_navigate_' + this.htmlId + '_',
      txt_quick_search: 'txt_quick_search_' + this.htmlId
    }
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.items.forEach((x, idx) => {
      x.v5 = x.v1?.toLowerCase() ?? '';
    });
    this.sideBarBodyHeight = window.outerHeight - 150;
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        const item = this.items.find(x => x.key == key);
        if (item.isSelected) {
          this.onClicked.emit({ key: item.key, value: item.v3 } as KeyValueId);
          this.onCloseTrigger();
        } else {
          this.onCloseTrigger();
          this.router.navigate([item.v3]);
        }
      } break;
    }
  }
}
